export const RISK_TIER = {
  VERY_HIGH: 'very-high',
  HIGH: 'high',
  STANDARD: 'standard',
  LOW: 'low',
  VERY_LOW: 'very-low'
};

export const RISK_TIER_LABELS = {
  [RISK_TIER.VERY_HIGH]: 'Very High Risk',
  [RISK_TIER.HIGH]: 'High Risk',
  [RISK_TIER.STANDARD]: 'Standard Risk',
  [RISK_TIER.LOW]: 'Low Risk',
  [RISK_TIER.VERY_LOW]: 'Very Low Risk'
};

export const RISK_TIER_CUMULATIVE_TARGETS = {
  [RISK_TIER.VERY_HIGH]: 0.80,
  [RISK_TIER.HIGH]: 0.60,
  [RISK_TIER.LOW]: 0.10,
  [RISK_TIER.VERY_LOW]: 0.05
};

export const FLAGGED_RISK_TIERS = [
  RISK_TIER.VERY_HIGH,
  RISK_TIER.HIGH,
  RISK_TIER.LOW,
  RISK_TIER.VERY_LOW
];
